module.exports = __webpack_public_path__ + "img/9788993285697.77b3ea2f.jpg";